/**
 * Creates a curried function for alpha numberic validation.
 * The validator checks the value is not of 0 length, and has a max length as defined.
 * The validator also checks if the value consists of alphanumerical characters.
 *
 * @function
 * @name createAlphanumericValidator
 * @param {number} length
 * @returns {boolean}
 */
export const createAlphanumericValidator = (length: number): (input: string) => boolean => {
  const regex = new RegExp(`^[\\w\\s]{1,${length}}$`);

  return (input: string) => regex.test(input);
};

/**
 * Creates a curried function for length validation.
 * The validator checks the length of a given string, regardless of any characters defined.
 * The length is valid if it is between 1 and the length defined. An empty length is invalid.
 *
 * @function
 * @name createLengthValidator
 * @param {number} length
 * @returns {boolean}
 */
export const createLengthValidator = (length: number): (input: string) => boolean => {
  const regex = new RegExp(`^.{1,${length}}$`);

  return (input: string) => regex.test(input);
};
